module.exports = __webpack_public_path__ + "static/media/freedomplan_1.56cffae4.svg";